import styled from "styled-components";

export const TextBadge = styled.span`
  align-items: center;
  background: #edebed;
  border: 1px solid #f0f0f0;
  color: rgba(0, 0, 0, 0.85);
  display: flex;
  margin-right: 5px;
  width: max-content;
  height: auto;
  margin: 4.5px;
  word-break: break-all;
  padding: 4px;
  gap: 8px;
  border-radius: 4px;
  opacity: 0px;
`;

export const BadgeDeleteBtn = styled.span`
  padding-top: 1px;
  display: flex;
  align-items: center;
  height: 12px;
  width: 12px;
  color: rgba(0, 0, 0, 0.45);
  cursor: pointer;

  &:hover {
    color: black;
  }
`;

export const InputBadgeWrapper = styled.div`
  box-sizing: border-box;
  margin: 0;
  padding: 0;
  color: rgba(0, 0, 0, 0.85);
  font-size: 14px;
  position: relative;
  display: inline-block;
  width: 100%;
  background-color: #fff;
  border: 1px solid #d9d9d9;
  border-radius: 2px;
  margin-bottom: 30px;
`;

export const InputBadgeCover = styled.div`
  display: inline-flex;
  flex-wrap: wrap;
  margin: 0;
  padding: 0;
  width: 100%;
  min-height: 38px;
  align-items: center;
`;

export const InputBadgeText = styled.input`
  border: none;
  width: 100%;
  padding-left: 11px;
  background: transparent;
  &:focus {
    outline: none;
  }
  &::placeholder {
    color: var(--grey-30, #AFB2B6) !important;

    font-style: italic;
  }
`;
export const Label = styled.div`
  color: var(--grey-95, #0C0D0D);
  font-size: 14px;
  font-family: "Montserrat Regular";
  font-weight: normal;
  margin-bottom: 8px;
`;
